var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"hidden top-0 left-0 opacity-0 pointer-event-none",class:[_vm.mjSlider.active ? 'selected' : '']},[_c('img',{staticClass:"wide shadow w-full",attrs:{"alt":"Fly Bag","src":_vm.mjSlider.img}})])
}
var staticRenderFns = []

export { render, staticRenderFns }